'use strict';

window.onload = function(e) {
  // Si Slider, afficher l'attribut alt en H2
  const sliderHome = document.querySelector('.home_slider');

  if (sliderHome !== null) {
    var altImg = document.querySelectorAll('.vc_inner img');

    for (let i = 0; i < altImg.length; i++) {
      altImg[i].insertAdjacentHTML('afterend', '<span class="h2-like">' + altImg[i].alt + '</span>');
    }
  }

  // Si bouton  afficher carte, changement de classe
  const btnDisplayMap = document.querySelector('.btn_display_gmap');

  if (btnDisplayMap !== null) {
    btnDisplayMap.onclick = function() {
      document.getElementById('google_map_prop_list_wrapper').classList.toggle('open');
    };
  }

  // Si formulaire avec fichier à uploader (contact agence), lors d'un clic sur le bouton d'ajout d'un fichier, le champ d'upload se déroule.
  const formidable = document.querySelector('.frm_forms');

  if (formidable !== null) {
    [].forEach.call(document.querySelectorAll('.frm_file .frm_primary_label'), function(el) {
      el.addEventListener('click', function() {
        el.nextElementSibling.nextElementSibling.classList.toggle('open');
      });
    });
  }

  // Si adresse renseignée, passage à la ligne avant le code postal (faute à l'ACF du thème)
  const adressLocale = document.querySelector('.address__locale, .property__agency > div[itemprop="address"]');

  if (adressLocale !== null) {
    adressLocale.innerHTML = adressLocale.innerHTML.replace(/\d{5}/, '<br/><span>$&');
    adressLocale.innerHTML += '</span>';
  }

  // Trad moteur de recherche
  const catField = document.querySelector('#advanced_search_shortcode #shortcode-adv_categ');

  if (catField !== null) {
    catField.firstChild.textContent = 'Tous types de biens';
  }
};
